import { AlertVariants } from '@pmi/dsm-react/dist/types';
import { AlertMessage } from '../components/AlertGroup/models';
import { getMyPMISiteUrl } from '../env-vars';

export const defaultWelcomeContent =
  "On behalf of the entire Learning and Development Team we are thrilled to guide you on your journey to maximize project success!  The Partner Platform will be your central hub to access products through our organization.\n\nBelow you have been granted access to the following products brought to you by PMI, the global authority on project management.  You can enroll in new products or explore products you've already enrolled in.\n\nIf you have questions or need assistance getting started please contact your platform administrator ([[AdminContact]]).";

export const defaultWelcomeTitle = 'Welcome to Your PMI Partner Platform';

export const HomeScreenAlertMessages: AlertMessage[] = [
  {
    id: 'home_static_alert',
    message: `The partner platform is your central hub for managing your training program with PMI.
      From inviting users to tracking progress and spending, these tools will help you deliver an effective and seamless experience for your learners.`,
    type: 'info' as AlertVariants,
    category: 'static',
  },
];

export const ProductGroupsAlertMessages: AlertMessage[] = [
  {
    id: 'productgroups_static_alert',
    message: `Product Groups help you manage which users have access to which products.
    Easily create a product group by choosing which products you want that group to have access to and then inviting users to the group.
    Add or remove products from a group any time, ensuring your training is customized to your needs and always up-to-date.`,
    type: 'info' as AlertVariants,
    category: 'static',
  },
];

export const B2CPRODUCTLOCATION = {
  Certification: {
    prefix: 'under your',
    title: 'Certifications.',
    link: `${getMyPMISiteUrl()}/certification`,
  },

  eLearning: {
    prefix: 'in your',
    title: 'Course Library.',
    link: `${getMyPMISiteUrl()}/library`,
  },
  'Digital Product': {
    prefix: 'under your',
    title: 'Micro-Credentials.',
    link: `${getMyPMISiteUrl()}/certification/my-micro-credentials`,
  },
};
